import React from 'react';
import ChartPage from './components/ChartPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <ChartPage />
    </div>
  );
}

export default App;
